<template>
  <footer class="footer bg-white shadow flex-shrink-0 px-4 py-2 border-t border-solid border-slate-200">
    <div class="w-full max-w-content mx-auto flex flex-col md:flex-row space-y-3 md:space-y-0 items-center justify-between">
      <div :class="customls" class="overflow-hidden">
        <slot name="ls" />
      </div>
      <div :class="customrs" class="flex-shrink-0 w-full md:w-auto">
        <slot name="rs" />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'BaseFooter',
  props: {
    customls: {
      type: String,
      default: ''
    },
    customrs: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
